import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';
import { Button } from '@shared/widgets';

interface SuccessProps {
  text?: string;
}

export const Success = (props: SuccessProps) => {
  const { t } = useTranslation();

  return (
    <div className='absolute z-1 !bg-[#fcfcfc]/90 left-0 right-0 top-0 bottom-0 flex flex-col flex-nowrap justify-center items-center capitalize'>
      <svg xmlns='http://www.w3.org/2000/svg' width='30' height='21' viewBox='0 0 30 21'>
        <path
          fill={clsx(PaletteUtils.isBordierPalette ? '#dc291c' : '#be8b45')}
          d='M28.436 0L10.783 17.839 1.564 8.523 0 10.104 10.783 21 30 1.58z'
        />
      </svg>
      <p className={'m-4 text-center'}>{props.text ?? t('success.description')}</p>
      <Button
        className={clsx('px-5 tracking-normal', PaletteUtils.isBordierPalette ? 'text-[#4c4c52]' : 'text-black border-[#be8b45]')}
        caption={t('success.buttons.back')}
        url='/'
      />
    </div>
  );
};
